import {
  SET_SHIPS,
  SET_COLLECTION,
  FETCH_COLLECTION,
  RECEIVE_COLLECTION,
  FETCH_USER,
  RECEIVE_USER,
  SET_USER,
} from './actionTypes';

const requestOptions = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};
export const setCollection = collection => ({
  type: SET_COLLECTION,
  payload: collection,
});

export const setShips = ships => ({
  type: SET_SHIPS,
  payload: ships,
});

export const fetchCollection = id => ({
  type: FETCH_COLLECTION,
  payload: { id },
});

export const receiveCollection = payload => ({
  type: RECEIVE_COLLECTION,
  payload,
});

export const fetchCollection1 = id => {
  return dispatch => {
    fetch(`http://shoria.me:1323/collections/${id}`, requestOptions)
      .then(response => response.json())
      .then(json => dispatch(receiveCollection(json)));
  };
};

// --------------------------------------

export const setUser = user => ({
  type: SET_USER,
  payload: user,
});

export const requestUser = id => ({
  type: FETCH_USER,
  payload: { id },
});

export const receiveUser = payload => ({
  type: RECEIVE_USER,
  payload,
});

export const fetchUser = id => {
  return dispatch => {
    dispatch(requestUser());
    fetch(`http://shoria.me:1323/collections/${id}`, requestOptions)
      .then(response => response.json())
      .then(json => dispatch(receiveUser(json)));
  };
};
